import collegeLifeSummary from "../Images/college_life_summary.png";
import darksideAajaSanam from "../Images/darkside_x_aaja_sanam.png";
import doraemon from "../Images/doraemon.png";

function Music() {
  const items = [
    {
      title: "College life summary",
      thumbnail: collegeLifeSummary,
      link: "https://www.instagram.com/paritoshj_/reel/C6ePQLDRBZN/",
    },
    {
      title: "Darkside x Aaja Sanam",
      thumbnail: darksideAajaSanam,
      link: "https://www.instagram.com/paritoshj_/reel/DEF6aRKBO-T/",
    },
    {
      title: "Doraemon",
      thumbnail: doraemon,
      link: "https://www.instagram.com/paritoshj_/reel/DB_5BcMBpjF/",
    },
  ];

  return (
    <section className="text-gray-600 body-font">
      <div className="container px-5 py-24 mx-auto">
        <div className="flex flex-wrap w-full mb-10 flex-col items-center text-center">
          <h1 className="text-4xl font-bold text-green-600">
            Some covers...🎧
          </h1>
        </div>
        <div className="flex flex-wrap justify-center">
          {items.map((item, index) => (
            <a
              target="_blank"
              href={item.link}
              className="xl:w-1/4 md:w-1/2 p-4 transform transition duration-300 hover:scale-105 focus:outline-none focus:ring focus:ring-green-300"
              key={index}
            >
              <div className="hover:bg-green-100 p-6 rounded-lg">
                <img
                  src={item.thumbnail}
                  alt={item.title + " [PLEASE RELOAD IF IMAGE NOT LOADED]"}
                  className="img-responsive img-glow"
                  style={{ boxShadow: "-3px 3px 15px green" }}
                />
                <h2 className="text-lg text-gray-900 text-center font-medium mt-2">
                  {item.title}
                </h2>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Music;
